import React, { Component } from "react";
import { Link } from 'react-router-dom';

class EthicsBoard extends Component {
  render() {
    return (
    <div>
      <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">รู้จักสหกรณ์</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="ethicsboard" className="a-breadcrumbs">จรรยาบรรณ 10 ประการ สำหรับคณะกรรมการดำเนินการสหกรณ์</a>
              </div>
            </div>
          </div>
        </section>
        <section className="page-section">
          <div className="container">
            <div className="row">
              <div class="col-md-11 col-sm-11 mb-sm-50">
                <h2 className="title-section mt-0 mb-0"><span>จรรยาบรรณ 10 ประการ สำหรับคณะกรรมการดำเนินการสหกรณ์</span></h2><br/>
                <div>
                  <div className="divider gray left mt-20 mb-30" />
                  <p className="mb-30" style={{fontSize: 20}}>
                    1.	มุ่งมั่น และอุทิศตน เพื่อพัฒนาการบริหารงานของสหกรณ์ให้ก้าวหน้า  ด้วยความเสียสละ ซื่อสัตย์ และสุจริต โดยยึดมั่นอุดมการณ์ หลักการ และวิธีการสหกรณ์ <br />
                    2.	พึงรักษา ปกป้องผลประโยชน์ของสมาชิกโดยรวม  และตัดสินใจบนพื้นฐานประโยชน์สมาชิกอย่างเป็นธรรม <br />
                    3.	พึงปฏิบัติตามกฎหมาย ข้อบังคับ ระเบียบของสหกรณ์อย่างเคร่งครัด รวมถึงยึดหลักจริยธรรม วัฒนธรรมอันดีงาม <br />
                    4.	มุ่งพัฒนาความรู้ ศักยภาพของตนและบุคลากรของสหกรณ์อย่างจริงจัง เพื่อเพิ่มประสิทธิภาพการปฏิบัติงานในสหกรณ์ <br />
                    5.	กำกับดูแลการจัดการสหกรณ์ให้มีประสิทธิภาพและประสิทธิผล โดยไม่แทรกแซงสายการบังคับบัญชาแต่จะสร้างความยุติธรรมแก่เจ้าหน้าที่สหกรณ์ในการปฏิบัติงาน <br />
                    6.  พึงใช้ ดูแล และรักษาทรัพย์สิน อุปกรณ์ของสหกรณ์ให้เกิดประโยชน์สูงสุดแก่ส่วนรวม <br />
                    7.  ไม่อาศัยหรือยอมให้ผู้อื่นอาศัยตำแหน่งหน้าที่ในสหกรณ์ เพื่อให้ได้มาซึ่งประโยชน์ส่วนตน ญาติและพวกพ้อง <br />
                    8.  หลีกเลี่ยงการทำธุรกิจส่วนตนที่มีผลประโยชน์ทับซ้อนกับสหกรณ์ และเปิดเผยผลประโยชน์ส่วนตนที่มีในองค์กร หรือธุรกรรมใดที่ขัดกับประโยชน์ของสหกรณ์ <br />
                    9.  ละเว้นการให้สัญญาต่างตอบแทนแก่บุคคล องค์กร เพื่อให้ได้มาซึ่งตำแหน่ง ผลประโยชน์ของตน <br />
                    10. ไม่นำเอาทรัพย์สิน อุปกรณ์ บุคลากรของสหกรณ์ไปใช้เพื่อประโยชน์ของตนและพวกพ้อง และไม่กระทำการใดอันเป็นปฏิปักษ์ และเป็นคู่แข่งขันต่อการดำเนินงานของสหกรณ์
                  </p>
                </div>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>
            </div>
          </div>
        </section>

      </div>
      );
  }
}

export default EthicsBoard;
